import Navbar from "./components/Navbar";
import Background from "./components/Background";
import Destination from "./components/Destination";
import Search from "./components/Search";
import Slider from "./components/Slider";
import Footer from "./components/Footer";



function App() {
  return (
    <div>
      <Navbar />
      <Background />
      <Destination />
      <Search />
      <Slider />
      <Footer />
    </div>

  );
}

export default App;
